import Sidebar from '../components/layout/Sidebar';
import Header from '../components/layout/Header';
import { ExecSalary } from '../components/widgets/ExecSalary';

export default function ExecSalaryPage() {
  return (
    <div className="flex h-screen bg-gray-50">
      <Sidebar />
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header title="דשבורד תשלומים" />
        <main className="flex-1 overflow-y-auto p-6">
          <ExecSalary />
        </main>
      </div>
    </div>
  );
}
